import styles from './Memberdetails.module.css'

export type MemberdetailsProps = {
  title: string
  position?: any
  description?: any
  asset?: React.ReactNode
  memberList?: { label: string; values: string[]; links: string[] }[]
}

export const PhnxMemberdetails: React.FC<MemberdetailsProps> = ({
  title,
  position,
  description,
  asset,
  memberList,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedLink = event.target.value
    window.location.href = selectedLink
  }

  return (
    <div className={styles['memberdetails']}>
      <div
        className={styles['feature-image']}
        style={{
          backgroundImage: `url(/assets/banner-member.webp)`,
        }}
      ></div>

      <div className={`${styles['memberdetails-container']} container`}>
        <div className={styles['memberdetails-header']} id="memberdetails-header">
          <div className={styles['memberdetails-asset']}>{asset && asset}</div>
          <div className={styles['memberdetails-text']}>
            {title && <h1 className={styles['memberdetails-title']}>{title}</h1>}
            {position && <p className={styles['memberdetails-position']}>{position}</p>}
          </div>
        </div>
        <div className={styles['memberdetails-select']} id="memberdetails-select">
          <form>
            <select id={'memberlist'} name={'memberlist'} onChange={handleChange} value={''}>
              <option value="" disabled>
                Select Profile To View
              </option>
              {Array.isArray(memberList) &&
                memberList.map((option, index) => {
                  if (typeof option === 'object' && Array.isArray(option.values)) {
                    return (
                      <optgroup key={index} label={option.label}>
                        {option.values.map((value, idx) => (
                          <option key={`${index}-${idx}`} value={option.links[idx]}>
                            {value}
                          </option>
                        ))}
                      </optgroup>
                    )
                  }
                  return null
                })}
            </select>
          </form>
        </div>

        <div className={styles['memberdetails-description']} id="memberdetails-description">
          {description && description}
        </div>
      </div>
    </div>
  )
}
